var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.props,"fields":_vm.fields}})],1),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }